import { DynamicPricingAdjustmentData } from './dynamic-pricing-adjustment-data';

export interface DynamicPricingScheduleData {
  schedule: DynamicPricingAdjustmentData[];
  hasRounding: boolean;
  priceIncreaseAmount: number;
  totalAdjustmentAmount: number;
  adjustmentFrequency: string;
}
